/** Kampanjformulering för privatpersoner (ROT-avdrag på arbetskostnad). */
export const PROMO_30_KITCHEN = '30 % ROT-avdrag';
